import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import UserService from '../../services/userService';
import { ToastType, useToast } from '../toast/ToastProvider';
import { useTranslation } from 'react-i18next';

const ResetPassword = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ token: '', newPassword: '', confirmPassword: '' });
    const { showToast } = useToast();
    const { i18n } = useTranslation();
    const isRtl = i18n.language === 'he';
    const { token } = useParams();

    useEffect(() => {
        if (token) {
            setFormData(prev => ({ ...prev, token }));
        }
    }, [token]);

    const handleNavigateToLogin = () => {
        navigate('/login');
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    
    const handleResetPassword = async (e: React.FormEvent) => {
        e.preventDefault();

        const passwordRegex = /^(?=.*[A-Z])(?=.*\W).{8,}$/;

        if (!passwordRegex.test(formData.newPassword)) {
            showToast(t(`toastMessages.PASSWORD_REQUIREMENTS`), ToastType.Warning);
            return;
        }

        if (formData.newPassword !== formData.confirmPassword) {
            showToast(t(`toastMessages.PASSWORDS_DO_NOT_MATCH`), ToastType.Warning);
            return;
        }

        try {
            const response = await UserService.resetPassword(formData);
            const code = response.code;
            showToast(t(`resetPasswordMessages.${code}`), ToastType.Success);  
        } catch (error : any) {
            const code = error.response?.data?.code || 'UNKNOWN_ERROR';
            showToast(t(`resetPasswordMessages.${code}`), ToastType.Warning);
        }
    };

    return (
        <div className="container-scroller">
            <div className="container-fluid page-body-wrapper full-page-wrapper">
                <div className="row w-100 m-0">
                    <div className="content-wrapper full-page-wrapper d-flex align-items-center auth login-bg">
                        <div className="card col-lg-4 mx-auto">
                            <div className="card-body px-5 py-5">
                                <h3 className="card-title text-left mb-3">{t('reset-password')}</h3>
                                <form>
                                    <div className="form-group">
                                        <label className="text-gray">{t('password')}</label>
                                        <input type="password" placeholder={t('password')} onChange={handleChange} className="form-control p_input input-bg-dark text-white" name="newPassword" />
                                    </div>
                                    <div className="form-group">
                                        <label className="text-gray">{t('confirm-password')}</label>
                                        <input type="password" placeholder={t('confirm-password')} onChange={handleChange} className="form-control p_input input-bg-dark text-white" name="confirmPassword" />
                                    </div>
                                    <div className="text-center mt-5">
                                        <button type="submit" onClick={handleResetPassword} className="btn btn-primary btn-block enter-btn">{t('reset-password')}</button>
                                    </div>
                                    <p className="sign-up">
                                        <a className="btn btn-link" onClick={handleNavigateToLogin}> {t('login')}</a>
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
